// extracted by mini-css-extract-plugin
export default {"err":"ErrorSpan_err__tEfIe"};